import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseDeletePreInitialPublicOfferQueryType = {
  onSuccess?: UseMutationConfig<any>['onSuccess'];
  onReject?: UseMutationConfig<any>['onReject'];
};

export default function useDeletePreInitialPublicOfferQuery({
  onReject,
  onSuccess,
}: UseDeletePreInitialPublicOfferQueryType) {
  const { execute: deletePreInitialOffer, ...query } = useMutation(
    (order: string) => API.deletePreInitialPublicOffer(order),
    {
      onSuccess,
      onReject,
    }
  );

  return { deletePreInitialOffer, ...query };
}
